module.exports = __webpack_public_path__ + "img/default_avatar.d685212c.png";